import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {GenericDocApprovalSettingContainerModel} from '../../../../../../models/aggregates/erp/generic-approval';

@Injectable({providedIn: 'root'})
export class GenericDocApprovalSettingService extends BaseApiTemplateService<GenericDocApprovalSettingContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/approval-settings/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/approval-settings/backoffice-ep';
    this.httpClient = http;
  }

}
